const FCM_TOKEN = "fcmToken";
const FCM_USER_ID = "fcmUserId";
const FCM_TRANSPORT = "fcm";
const FCM_REGISTER_TOKEN_SUCCESS = "fcmRegisterTokenSuccess";

export { FCM_REGISTER_TOKEN_SUCCESS, FCM_TOKEN, FCM_TRANSPORT, FCM_USER_ID };
